import React, { FC, memo, useEffect, useState } from 'react';
import LazyImage from '@/components/common/lazy-image';
import classNames from 'classnames';
import styles from '@/styles/components/promotion-banner.module.scss';
import '@animxyz/core';
import { XyzTransition } from '@animxyz/react';

type Props = {
  bannerData: any;
  className: any;
};
const PromotionBanner: FC<Props> = memo(props => {
  const [isDisplayBanner, setIsDisplayBanner] = useState(false);

  const pageData = props.bannerData;
  const bannerData = pageData?.type_of_promotion[0] || null;

  const imagePcUrl = bannerData?.banner?.desktop_image?.url || '';
  const imageMobileUrl = bannerData?.banner?.mobile_image?.url || '';
  const redirectUrl = bannerData?.banner?.redirect_url || '';
  const openInNewTab = bannerData?.banner?.open_in_new_tab;
  const imageAltTag = bannerData?.banner?.image_alt_text;

  useEffect(() => {
    const startDateData = pageData?.start_date || '';
    const endDateData = pageData?.end_date || '';
    const startDate: any = startDateData ? new Date(startDateData) : null;
    const endDate: any = endDateData ? new Date(endDateData) : null;
    const currentDate = new Date();
    if (startDateData && !endDateData) {
      setIsDisplayBanner(currentDate >= startDate);
    } else if (!startDateData && endDateData) {
      setIsDisplayBanner(currentDate <= endDate);
    } else if (startDateData && endDateData) {
      setIsDisplayBanner(currentDate >= startDate && currentDate <= endDate);
    } else if (!startDateData && !endDateData) {
      setIsDisplayBanner(true);
    }
  }, []);

  return (
    <>
      {bannerData && isDisplayBanner ? (
        <div className={classNames(props.className)}>
          <div className={classNames(styles.MuiContainer_root, styles.MuiContainer_maxWidthXl)}>
            <XyzTransition appearVisible xyz=" delay-1 fade-100% down-2">
              <div className={styles.Advertise}>
                <div className={styles.Image_Container}>
                  <a
                    href={redirectUrl}
                    target={openInNewTab ? '_blank' : ''}
                    className={styles.Image_Pc}
                  >
                    {imagePcUrl && (
                      <LazyImage
                        src={imagePcUrl}
                        alt={imageAltTag}
                        width={'100%'}
                        height={'100%'}
                      />
                    )}
                  </a>
                  <a
                    href={redirectUrl}
                    target={openInNewTab ? '_blank' : ''}
                    className={styles.Image_Mobile}
                  >
                    {imageMobileUrl && (
                      <LazyImage
                        src={imageMobileUrl}
                        alt={imageAltTag}
                        width={'100%'}
                        height={'100%'}
                      />
                    )}
                  </a>
                </div>
              </div>
            </XyzTransition>
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  );
});
export default PromotionBanner;
